
import { inject, Injectable, DOCUMENT } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class BrowserService {
  public document = inject(DOCUMENT);
  public meta = inject(Meta);
  public title = inject(Title);
  // see: Meta
  getMetaTag            = (...args:Parameters<Meta["getTag"]>) => this.meta.getTag(...args)
  getMetaTags           = (...args:Parameters<Meta["getTags"]>) => this.meta.getTags(...args)
  addMetaTag            = (...args:Parameters<Meta["addTag"]>) => this.meta.addTag(...args)
  addMetaTags           = (...args:Parameters<Meta["addTags"]>) => this.meta.addTags(...args)
  updateMetaTag         = (...args:Parameters<Meta["updateTag"]>) => this.meta.updateTag(...args)
  removeMetaTag         = (...args:Parameters<Meta["removeTag"]>) => this.meta.removeTag(...args)
  removeMetaTagElement  = (...args:Parameters<Meta["removeTagElement"]>) => this.meta.removeTagElement(...args)
  // see: Title
  setTitle = (...args:Parameters<Title['setTitle']>) => this.title.setTitle(...args)
  getTitle = (...args:Parameters<Title['getTitle']>) => this.title.getTitle(...args)
}
